module.exports = __webpack_public_path__ + "img/score4.d59ee4a5.png";